import { useEffect, useState } from "react";

import { QueryScopeType } from "@interfaces/index";
import { useCommonStore } from "@stores/index";
import {
  Drawer,
  DrawerHeader,
  DrawerScrollableContainer,
  NewQueryCategoryButton,
  NewQuerySoftware,
  NewQueryAccountSubmission,
} from "@components/index";

export const NewQueryDrawer = ({
  businessId,
  startDate,
  endDate,
  show,
  onClose,
  presetCategory,
  presetTopicId,
  presetCallRequested,
  title,
}: {
  businessId?: string;
  startDate?: string;
  endDate?: string;
  show: boolean;
  onClose: () => void;
  presetCategory?: QueryScopeType | "software";
  presetTopicId?: string;
  presetCallRequested?: boolean;
  title?: string;
}) => {
  const setState = useCommonStore(({ setState }) => setState);
  const [category, setCategory] = useState<
    QueryScopeType | "software" | undefined
  >(presetCategory);

  useEffect(() => {
    if (show) {
      setCategory(presetCategory);
    }
  }, [show, presetCategory]);

  const handleClose = () => {
    setState({ isDrawerShown: false });
    setCategory(undefined);
    onClose();
  };

  if (!show) {
    return null;
  }

  return (
    <Drawer>
      <DrawerHeader
        onClose={handleClose}
        title={
          <div className="text-300 font-bold capitalize text-black-100 md:text-600">
            {title ? title : <>New {category} Query</>}
          </div>
        }
      />
      <DrawerScrollableContainer className="max-h-[calc(100dvh_-_50px)] pt-6 md:max-h-[calc(100dvh_-_100px)] md:pt-10">
        {!category && (
          <>
            <div className="text-200 text-black-54">
              What type of query is this?
            </div>
            <div className="mt-6 flex flex-col gap-y-3">
              <NewQueryCategoryButton
                title="Submission query"
                description="Questions about your submissions, transactions"
                onClick={() => setCategory("submission")}
              />
              <NewQueryCategoryButton
                title="Account query"
                description="Questions about your accounts, tax"
                onClick={() => setCategory("account")}
              />
              <NewQueryCategoryButton
                title="Software query"
                description="Something not working as expected in the app"
                note="Handled by our tech support team, not your accountant"
                onClick={() => setCategory("software")}
              />
            </div>
          </>
        )}
        {category === "software" && (
          <NewQuerySoftware
            onBack={!presetCategory ? () => setCategory(undefined) : undefined}
            onClose={() => handleClose()}
          />
        )}
        {(category === "account" || category === "submission") && (
          <NewQueryAccountSubmission
            businessId={businessId}
            category={category}
            presetTopicId={presetTopicId}
            startDate={startDate}
            endDate={endDate}
            callRequested={!!presetCallRequested}
            onBack={!presetCategory ? () => setCategory(undefined) : undefined}
            onClose={() => handleClose()}
          />
        )}
      </DrawerScrollableContainer>
    </Drawer>
  );
};
